/*
 * AE GLP lander (/pages/awesome-everyday-glp) — sticky add-to-cart bar.
 * Verbatim copy of assets/sticky-atc-bar.js (live, 2026-09-30), loaded only by
 * sections/aminos-ae-glp-sticky-atc.liquid. Defines <sticky-atc-bar>; the
 * theme copy is not loaded on this page (the layout only renders it on products).
 */
if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.updateChatClearance = this.updateChatClearance.bind(this);
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.purchaseLabel = this.querySelector('[data-aa-sticky-purchase-label]');
        this.selectedPrice = this.querySelector('[data-aa-sticky-selected-price]');
        this.selectedCompare = this.querySelector('[data-aa-sticky-selected-compare]');
        this.purchasePricing = null;

        this.variantData = this.getVariantData();

        if (this.productForm) {
          this.productForm.addEventListener('submit', this.handleStickySubmit.bind(this), { capture: true });
        }
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.handleStickySubmit.bind(this), { capture: true });
        }

        this.handlePurchaseOptionChange = (event) => this.syncPurchaseOption(event.detail || {});
        document.addEventListener('aa:pdp-purchase-option:changed', this.handlePurchaseOptionChange);

        const mainPicker = document.querySelector('[data-aa-pdp-sub-picker]');
        const mainPlanInput = mainPicker && mainPicker.querySelector('[data-aa-pdp-sub-plan-input]');
        const mainPricingData = mainPicker && mainPicker.querySelector('[data-aa-pdp-sub-pricing]');
        let mainPricing = null;
        try {
          const prices = mainPricingData ? JSON.parse(mainPricingData.textContent) : [];
          mainPricing = prices.find((entry) => Number(entry.variantId) === Number(mainPicker && mainPicker.dataset.variantId)) || prices[0] || null;
        } catch (error) {
          mainPricing = null;
        }
        const mainSubscription = Boolean(mainPlanInput && mainPlanInput.value);
        this.syncPurchaseOption({
          mode: mainSubscription ? 'subscription' : 'one_time',
          sellingPlanId: (mainPlanInput && mainPlanInput.value) || '',
          unitPriceCents: mainPricing
            ? (mainSubscription ? mainPricing.subscriptionPrice : mainPricing.oneTimePrice)
            : 0,
          unitCompareCents: mainPricing
            ? (mainSubscription ? mainPricing.subscriptionCompare : mainPricing.oneTimeCompare)
            : 0,
          price: mainSubscription
            ? (mainPicker && mainPicker.querySelector('[data-aa-pdp-sub-price]')?.textContent)
            : (mainPicker && mainPicker.querySelector('[data-aa-pdp-otp-price]')?.textContent),
          comparePrice: mainSubscription
            ? (mainPicker && mainPicker.querySelector('[data-aa-pdp-sub-compare]')?.textContent)
            : '',
        });

        if ('ResizeObserver' in window && this.container) {
          this.chatClearanceObserver = new ResizeObserver(this.updateChatClearance);
          this.chatClearanceObserver.observe(this.container);
        }

        this.init();
        if (this.quantityInput) {
          const syncStickyQuantity = () => this.updatePurchasePricing();
          this.quantityInput.addEventListener('change', syncStickyQuantity);
          this.quantityInput.addEventListener('input', syncStickyQuantity);
        }
        this.select.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });

        // The stock theme redirects sticky submits to the main product form when
        // required/custom fields exist. On this store that left the drawer open
        // but the cart empty, because subscription/app fields live outside that
        // handoff. The sticky form already contains the correct variant and
        // selling plan, so it should own its add-to-cart action.
      }

      disconnectedCallback() {
        if (this.handlePurchaseOptionChange) {
          document.removeEventListener('aa:pdp-purchase-option:changed', this.handlePurchaseOptionChange);
        }
      }

      syncPurchaseOption(detail) {
        if (!this.productForm) return;
        const selectedQuantity = Math.max(1, Number.parseInt(detail.quantity, 10) || 1);
        this.purchaseQuantity = selectedQuantity;
        if (this.quantityInput && Number.parseInt(this.quantityInput.value, 10) !== selectedQuantity) {
          this.quantityInput.value = String(selectedQuantity);
        } else if (!this.quantityInput) {
          let quantityInput = this.productForm.querySelector('[data-aa-sticky-quantity-input]');
          if (!quantityInput) {
            quantityInput = document.createElement('input');
            quantityInput.type = 'hidden';
            quantityInput.name = 'quantity';
            quantityInput.setAttribute('data-aa-sticky-quantity-input', '');
            this.productForm.prepend(quantityInput);
          }
          quantityInput.value = String(selectedQuantity);
        }
        const planId = String(detail.sellingPlanId || '');
        let planInput = this.productForm.querySelector('[data-aa-sticky-plan-input]');

        if (planId) {
          if (!planInput) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            planInput.setAttribute('data-aa-sticky-plan-input', '');
            this.productForm.prepend(planInput);
          }
          planInput.value = planId;
        } else if (planInput) {
          planInput.remove();
        }

        if (this.purchaseLabel) {
          this.purchaseLabel.textContent = planId ? 'Subscribe & save' : 'One-time purchase';
        }
        this.purchasePricing = {
          unitPriceCents: Number(detail.unitPriceCents) || 0,
          unitCompareCents: Number(detail.unitCompareCents) || 0,
          price: detail.price || '',
          comparePrice: detail.comparePrice || '',
        };
        this.updatePurchasePricing();
        this.dataset.purchaseMode = planId ? 'subscription' : 'one_time';
      }

      updatePurchasePricing() {
        if (!this.purchasePricing) return;
        const quantity = Math.max(1, Number.parseInt(this.quantityInput && this.quantityInput.value, 10) || this.purchaseQuantity || 1);
        const theme = window.FoxTheme || {};
        const moneyFormat = theme.settings && theme.settings.moneyFormat;
        const formatMoney = (cents) => {
          if (theme.Currency && typeof theme.Currency.formatMoney === 'function' && moneyFormat) {
            return theme.Currency.formatMoney(cents, moneyFormat);
          }
          return `$${(Number(cents || 0) / 100).toFixed(2)}`;
        };
        const unitPrice = this.purchasePricing.unitPriceCents;
        const unitCompare = this.purchasePricing.unitCompareCents;
        const hasNumericPrices = unitPrice > 0;

        if (this.selectedPrice) {
          this.selectedPrice.textContent = hasNumericPrices
            ? formatMoney(unitPrice * quantity)
            : this.purchasePricing.price;
        }
        if (this.selectedCompare) {
          const showCompare = hasNumericPrices
            ? unitCompare > unitPrice
            : Boolean(this.purchasePricing.comparePrice);
          this.selectedCompare.textContent = showCompare
            ? (hasNumericPrices ? formatMoney(unitCompare * quantity) : this.purchasePricing.comparePrice)
            : '';
          this.selectedCompare.hidden = !showCompare;
        }
      }

      async handleStickySubmit(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
        }
        if (this.isSubmitting || !this.productForm || !this.submitButton) return;

        const formData = new FormData(this.productForm);
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const sellingPlanId = Number(formData.get('selling_plan') || 0);
        if (!variantId) return;

        const payload = {
          id: variantId,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        };
        if (sellingPlanId) payload.selling_plan = sellingPlanId;

        this.isSubmitting = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('btn--loading');

        try {
          const cartClient = window.aminosCartClient;
          if (cartClient && typeof cartClient.add === 'function') {
            await cartClient.add(payload);
          } else {
            await this.fallbackAdd(payload);
          }

          document.dispatchEvent(new CustomEvent('product-ajax:added', {
            bubbles: true,
            detail: { product: payload },
          }));

          this.openCartDrawer();
        } catch (error) {
          console.error('[sticky-atc-bar] Add to cart failed', error);
          document.dispatchEvent(new CustomEvent('product-ajax:error', {
            bubbles: true,
            detail: { errorMessage: 'Unable to add this product to cart. Please try again.' },
          }));
        } finally {
          this.submitButton.classList.remove('btn--loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.isSubmitting = false;
        }
      }

      async fallbackAdd(payload) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error('Cart add failed: ' + response.status);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        return response.json();
      }

      openCartDrawer() {
        // Dispatch cart:refresh rather than calling drawer.show() directly:
        // show() only toggles visibility, the actual re-fetch of cart
        // contents happens in cart-drawer's cart:refresh listener
        // (assets/cart.js CartDrawer.onCartRefresh), which also opens the
        // drawer itself once refreshed (detail.open) — calling show()
        // directly risked a race where the drawer opened before the
        // refresh finished.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          this.updateChatClearance();
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
              this.updateChatClearance();
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
        this.updateChatClearance();
      }

      updateChatClearance() {
        if (!this.container) return;
        const isVisible = this.container.classList.contains('sticky-atc-bar--show');
        const rect = this.container.getBoundingClientRect();
        const previewOffset = Number.parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--aa-sticky-preview-offset')
        ) || 0;
        const clearance = isVisible ? Math.ceil(rect.height + previewOffset + 16) : 0;
        document.documentElement.style.setProperty('--aa-sticky-chat-clearance', `${clearance}px`);
        document.documentElement.classList.toggle('aa-sticky-atc-visible', isVisible);
      }

      disconnectedCallback() {
        if (this.chatClearanceObserver) this.chatClearanceObserver.disconnect();
        document.documentElement.classList.remove('aa-sticky-atc-visible');
        document.documentElement.style.setProperty('--aa-sticky-chat-clearance', '0px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = 'Get yours now';
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}

(function () {
  if (window.__aaStickyAtcSubmitBound) return;
  window.__aaStickyAtcSubmitBound = true;

  function updateShopifyPreviewOffset() {
    const wrapper = document.getElementById('PBarNextFrameWrapper');
    const height = wrapper ? Math.ceil(wrapper.getBoundingClientRect().height || 0) : 0;
    document.documentElement.style.setProperty('--aa-sticky-preview-offset', height > 0 ? `${height}px` : '0px');
    if (document.body) {
      document.body.classList.toggle('aa-shopify-preview-bar-active', height > 0);
    }
  }

  function watchShopifyPreviewBar() {
    updateShopifyPreviewOffset();
    window.setTimeout(updateShopifyPreviewOffset, 300);
    window.setTimeout(updateShopifyPreviewOffset, 1000);

    const previewObserver = new MutationObserver(updateShopifyPreviewOffset);
    previewObserver.observe(document.documentElement, { childList: true, subtree: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateShopifyPreviewOffset);
      const attachResizeObserver = () => {
        const wrapper = document.getElementById('PBarNextFrameWrapper');
        if (wrapper) resizeObserver.observe(wrapper);
      };
      attachResizeObserver();
      window.setTimeout(attachResizeObserver, 500);
    }

    window.addEventListener('resize', updateShopifyPreviewOffset, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchShopifyPreviewBar, { once: true });
  } else {
    watchShopifyPreviewBar();
  }

  async function refreshCartDrawer() {
    try {
      const sectionElement = document.querySelector('cart-drawer[data-section-id]');
      const sectionId = (sectionElement && sectionElement.getAttribute('data-section-id')) || 'cart-drawer';
      const routes = window.FoxTheme && window.FoxTheme.routes ? window.FoxTheme.routes : {};
      const rootUrl = routes.root_url || '/';
      const cartUrl = routes.cart_url || '/cart';
      const [htmlResponse, cartResponse] = await Promise.all([
        fetch(`${rootUrl}?section_id=${sectionId}`, { credentials: 'same-origin' }),
        fetch(`${cartUrl}.js`, { credentials: 'same-origin' }),
      ]);
      const [html, cartData] = await Promise.all([htmlResponse.text(), cartResponse.json()]);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const renderedDrawer = parsed.getElementById(`CartDrawer-${sectionId}`);

      if (
        window.FoxTheme
        && window.FoxTheme.pubsub
        && window.FoxTheme.pubsub.PUB_SUB_EVENTS
        && window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate
      ) {
        cartData.sections = {};
        if (renderedDrawer) cartData.sections[sectionId] = renderedDrawer.innerHTML;
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });
      }
    } catch (error) {
      console.error('[sticky-atc-bar] Cart drawer refresh failed', error);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    }
  }

  function openCartDrawer(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show(trigger);
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    window.setTimeout(() => {
      const cartTrigger = document.querySelector('.cart-drawer-button[aria-controls="CartDrawer"], [data-cart-trigger]');
      if (cartTrigger) cartTrigger.click();
    }, 250);
  }

  async function submitStickyForm(form, trigger) {
    if (window.__aaStickyAtcSubmitting || !form) return;
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    const sellingPlanId = Number(formData.get('selling_plan') || 0);
    if (!variantId) return;

    const payload = {
      id: variantId,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
    };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;

    window.__aaStickyAtcSubmitting = true;
    if (trigger) {
      trigger.setAttribute('aria-disabled', 'true');
      trigger.classList.add('btn--loading');
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || `Cart add failed: ${response.status}`);

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        bubbles: true,
        detail: { product: result },
      }));
      await refreshCartDrawer();
      openCartDrawer(trigger);
    } catch (error) {
      console.error('[sticky-atc-bar] Add to cart failed', error);
      document.dispatchEvent(new CustomEvent('product-ajax:error', {
        bubbles: true,
        detail: { errorMessage: 'Unable to add this product to cart. Please try again.' },
      }));
    } finally {
      if (trigger) {
        trigger.classList.remove('btn--loading');
        trigger.removeAttribute('aria-disabled');
      }
      window.__aaStickyAtcSubmitting = false;
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target && event.target.closest
      ? event.target.closest('.sticky-atc-bar .product-form__submit')
      : null;
    if (!trigger) return;
    const form = trigger.closest('form');
    if (!form || !form.closest('.sticky-atc-bar')) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    submitStickyForm(form, trigger);
  }, true);

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.closest || !form.closest('.sticky-atc-bar')) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    const trigger = form.querySelector('.product-form__submit');
    submitStickyForm(form, trigger);
  }, true);
})();
